export const PropListSelector = (state) => state.properties.propsList;
export const PropsAreaSelector = (state) => state.properties.propsArea;
export const PropsCategSelector = (state) => state.properties.propsCateg;
export const filterFormSearchListSelector = (state) => state.properties.filterForm_SearchList;
export const PropDetailSelector = (state) => state.properties.propDetails;

